/*
 * Form field primitives — DESIGN.md §3 (labels) & §4 (fields).
 * Label: 12px / 600 / uppercase / letter-spacing .04em.
 * Input: 44px high, 1.5px #e6e1f2 border, #FBFAFF bg, radius 11px, violet focus.
 */
const baseInput = {
  width: '100%',
  height: 'var(--field-height)',
  padding: '0 14px',
  borderRadius: 'var(--radius-field)',
  border: '1.5px solid var(--color-border-strong)',
  background: 'var(--color-bg-field)',
  fontSize: 14,
  color: 'var(--color-ink)',
}

export function Field({ label, htmlFor, hint, error, required, children, style }) {
  return (
    <div style={{ marginBottom: 16, ...style }}>
      {label && (
        <label htmlFor={htmlFor} className="field-label">
          {label}{required && <span style={{ color: 'var(--color-danger)' }}> *</span>}
        </label>
      )}
      {children}
      {hint && !error && <div style={{ fontSize: 12, color: 'var(--color-text-muted)', marginTop: 5 }}>{hint}</div>}
      {error && <div style={{ fontSize: 12, color: 'var(--color-danger)', marginTop: 5 }}>{error}</div>}
    </div>
  )
}

export function Input({ style, ...rest }) {
  return <input style={{ ...baseInput, ...style }} {...rest} />
}

export function Textarea({ style, rows = 3, ...rest }) {
  return <textarea rows={rows} style={{ ...baseInput, height: 'auto', padding: '10px 14px', resize: 'vertical', ...style }} {...rest} />
}

export function Select({ style, children, ...rest }) {
  return (
    <select style={{ ...baseInput, appearance: 'none', cursor: 'pointer', ...style }} {...rest}>
      {children}
    </select>
  )
}
